import type { ReactNode } from "react";
import { twMerge } from "tailwind-merge";
import { Button } from "@/core/shared/v2/ui/button";

type UpsellCardProps = {
  header: string;
  description: string;
  buttonText: string;
  onClick: () => void;
  icon?: ReactNode;
  className?: string;
};

export const UpsellCard = ({ icon, header, description, buttonText, onClick, className }: UpsellCardProps) => (
  <div
    className={twMerge("flex w-full flex-col overflow-hidden rounded-2xl bg-white shadow-xl sm:flex-row", className)}
  >
    {icon && <div className="flex items-center justify-center bg-[#F5EDE4] p-8 sm:w-48 [&>svg]:size-12">{icon}</div>}
    <div className="flex flex-1 flex-col items-center gap-2 p-8 text-center sm:items-start sm:text-left">
      <h2 className="font-semibold text-lg">{header}</h2>
      <p className="text-sm text-zinc-600">{description}</p>
      <Button variant="secondary" className="mt-4 w-full sm:w-auto" onClick={onClick}>
        {buttonText}
      </Button>
    </div>
  </div>
);
